/* eslint-disable no-undef */
import { styled } from '@mui/material';

export const Styles = {
  Main: styled('div')({
    backgroundColor: '#ebebeb',
    display: 'flex',
    gap: '5px',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 0'
  }),
  Container: styled('div')({
    maxWidth: '1185px',
    width: '100%',
    margin: '0 auto',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  }),
  LabelTipo: styled('div')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '24px',
    color: 'black',
    marginBottom: '20px',
    [theme.breakpoints.down('md')]: {
      paddingRight: '0',
      fontSize: '18px',
      textAlign: 'center',
      width: '100%'
    }
  })),
  Select: styled('select')({
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #000000',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    backgroundColor: 'white',
    appearance: 'none',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 1rem center',
    backgroundSize: '1em',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    }
  }),
  Label: styled('label')({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    lineHeight: '27px',
    color: '#212529',
    '&.required::after': {
      content: '" *"',
      color: '#FF0000',
      marginRight: '5px'
    }
  }),
  Input: styled('input')({
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #000000',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    }
  }),
  SectionTitle: styled('h2')({
    color: '#04682E',
    fontSize: '20px',
    borderBottom: '2px solid #04682E',
    paddingBottom: '8px',
    width: '100%',
    margin: '30px 0 15px 0'
  }),

  TextArea: styled('textarea')({
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #000000',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    minHeight: '100px',
    resize: 'vertical',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    }
  }),

  InputContainer: styled('div')<{ fullWidth?: boolean; width?: string }>(
    ({ fullWidth, width, theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      flex: fullWidth ? '0 0 100%' : width ? `0 0 ${width}` : '1',
      [theme.breakpoints.down('md')]: {
        flex: '0 0 100%'
      }
    })
  ),

  FormRow: styled('div')({
    display: 'flex',
    gap: '20px',
    marginBottom: '20px',
    flexWrap: 'wrap'
  }),

  Button: styled('button')(({ theme }) => ({
    width: '150px',
    marginLeft: '5px',
    padding: '10px 30px',
    fontSize: '16px',
    backgroundColor: '#125dae',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginLeft: '0',
      fontSize: '14px'
    },
    '&:hover': {
      backgroundColor: '#0B327A'
    }
  }))
};
